export const TagIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M1.33985 1.06643L6.9119 1.06663L13.2683 7.42306L7.69633 12.9951L1.33991 6.63863L1.33985 1.06643ZM4.77328 6.75016C6.01592 6.75016 7.02328 5.7428 7.02328 4.50016C7.02328 3.25752 6.01592 2.25016 4.77328 2.25016C3.53064 2.25016 2.52328 3.25752 2.52328 4.50016C2.52328 5.7428 3.53064 6.75016 4.77328 6.75016Z"
      fill="#cc1426"
      stroke="#cc1426"
      strokeWidth="1.5"
    />
  </svg>
);
